<template>
    <v-data-table
        class="applications"
        :headers="headers"
        :items="applications"
        :loading="loading"
        no-data-text="Keine Daten verfügbar"
        hide-default-footer
        disable-pagination
    >
        <template slot="item" slot-scope="props">
            <tr>
                <td> {{ props.item.id }}</td>
                <td> {{ props.item.app }}</td>
                <td> {{ props.item.description }}</td>
                <td> {{ props.item.createdAt | toDatetime }}</td>
                <td> {{ props.item.updatedAt | toDatetime }}</td>
                <td>
                    <v-btn
                        text
                        icon
                        class="drei_60-btn"
                        @click="editApplication(props.item.id)"
                        :disabled="loading"
                    >
                        <v-icon>mdi-square-edit-outline</v-icon>
                    </v-btn>
                </td>
            </tr>
        </template>
    </v-data-table>
</template>

<script>
import { mapActions, mapState } from 'vuex';

export default {
    name: 'Applications',
    computed: mapState('applications', [
        'loading',
        'applications',
    ]),
    data() {
        return {
            headers: [{
                text: '#',
                align: 'left',
                sortable: true,
                value: 'id',
            }, {
                text: 'Anwendungsname',
                align: 'left',
                sortable: true,
                value: 'app',
            }, {
                text: 'Beschreibung',
                align: 'left',
                sortable: true,
                value: 'description',
            }, {
                text: 'Erstellt',
                align: 'left',
                sortable: true,
                value: 'createdAt',
            }, {
                text: 'Aktualisiert',
                align: 'left',
                sortable: true,
                value: 'updatedAt',
            }, {
                text: 'Editieren',
                align: 'left',
                sortable: false,
                value: 'id',
            }],
        };
    },
    methods: {
        ...mapActions('applications', ['editApplicationById']),
        editApplication(id) {
            this.editApplicationById(id).catch(() => null);
        },
    },
};

</script>
<style scoped lang="scss"></style>
